import ExternalIcon from "../ExternalIcon";
import style from "./FooterNav.module.css";
import type { FooterNavProps } from "./types";

const FooterNav: React.FC<FooterNavProps> = ({ title, links }) => {
  return (
    <nav className={style.footerNav}>
      <h6 className={style.footerNavTitle}>{title}</h6>
      <ul className={style.footerNavList}>
        {links?.map((link, index) => (
          <li key={index}>
            <a
              className={`muted ${style.footerNavLink}`}
              href={link.href}
              target={link.external ? "_blank" : "_self"}
            >
              {link.label}
              {link.external && <ExternalIcon />}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default FooterNav;
